export default __webpack_public_path__ + "static/media/applications-image-22.21cfd767.jpg";